import { useCallback, useContext, useEffect } from "react";
import { BoardContext, SocketContext, TeamContext } from "../context";
import { Phase } from "../util/enums";

const useGameData = () : { urlToken: string | undefined; gameId: string | undefined; } => {
	const { socket } = useContext(SocketContext);
	const { game, urlToken, setUrlToken, gameId, setGameId, setisLoaderHidden, setGameCount } = useContext(TeamContext);
	const { showStatistics } = useContext(BoardContext);

	const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

	useEffect(() => {
		setUrlToken(urlTokenExtracted); 
	}, [setUrlToken, urlTokenExtracted]);

	const setInitialDataInfo = useCallback(() => {
			fetch(
				process.env.REACT_APP_BACKEND_URL +
				"api/matches/" + urlTokenExtracted
			)
			.then((response) => {
				if (!response.ok)
					throw Error(response.statusText);
				
				return response.json();
			})
			.then((res) => {
				setGameCount(res.gameCount)
				setisLoaderHidden(false);
			})
			.catch((err) => { 
				console.error(err);
			});
	}, [setGameCount, setisLoaderHidden, urlTokenExtracted]);

	useEffect(() => {
		if (game?.phase === Phase.POSTGAME)
			showStatistics();
	}, [game?.phase, showStatistics]);

	useEffect(() => {
		setInitialDataInfo();
	}, [setInitialDataInfo]);

	const sendGameStateToFacilitatorSocketOn = useCallback(() => {
		socket?.on("sendGameStateToFacilitator", (data: any) => {})
	}, [socket]);

	useEffect( () => {
		if(socket)
			sendGameStateToFacilitatorSocketOn();
	}, [socket, sendGameStateToFacilitatorSocketOn]);
	
	useEffect( () => {
		let windowLocationPathname =  window.location.pathname;
	
		if(windowLocationPathname.includes("facilitator") && socket){
			let gameId = windowLocationPathname.replace("facilitator/", "").substr(1);
			socket?.emit("addFacilitator", { gameId } );
		}
	}, [socket])

	return {urlToken, gameId}
}

export default useGameData;